import { render, staticRenderFns } from "./ChatThreadLG.vue?vue&type=template&id=c0871fae&scoped=true&"
import script from "./ChatThreadLG.vue?vue&type=script&lang=js&"
export * from "./ChatThreadLG.vue?vue&type=script&lang=js&"
import style0 from "./ChatThreadLG.vue?vue&type=style&index=0&id=c0871fae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0871fae",
  null
  
)

export default component.exports